module.exports = __webpack_public_path__ + "static/media/Flag_of_United_Kingdom.526d1476.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/Flag_of_United_Kingdom.png
// module id = 454
// module chunks = 0